<template>
    <div v-if="selectedTeams" :class="expanded ? 'roster-team-table-scroll' : 'roster-team-table-scroll collapsed'" id="roster-team-table-scroll-day">
        <v-container v-if="loading" fill-height>
            <v-layout row align-center justify-center fill-height>
                <v-flex shrink>
                    <v-progress-circular indeterminate></v-progress-circular>
                </v-flex>
            </v-layout>
        </v-container>
        <table v-else-if="filteredSelectedTeams.length > 0" class="v-datatable v-table theme--light">
            <thead>
                <tr>                    
                    <th style="min-width:200px; padding: 4px 0px; border-bottom: 1px solid rgba(0,0,0,0.12);" align="center" rowspan="2">
                        <v-layout row>
                            <v-flex shrink>
                                <v-icon v-if="expanded" dark large @click="expand(false)">expand_more</v-icon>
                                <v-icon v-if="!expanded" dark large @click="expand(true)">expand_less</v-icon>
                            </v-flex>
                            <v-flex>
                                <v-autocomplete
                                    label="Team(s)"
                                    ref="rosterTeamFilterSelect"
                                    class="rosterTeamFilterSelect"
                                    :items="filteredSelectedTeams.concat({TeamID: -1, TeamName: 'Spray'})"
                                    @input="handleTeamFilterSelected"
                                    v-model="tempSelectedTeamsFilterIDs"
                                    hide-details
                                    dark
                                    item-value="TeamID"
                                    item-text="TeamName"
                                    multiple
                                    dense
                                    outline>
                                    <template v-slot:selection="{ item, index }">
                                        <span v-if="index === 0">{{ item.TeamName }}</span>
                                        <span
                                            v-if="index === 1"
                                            class="grey--text text-caption"
                                        >
                                            (+{{ tempSelectedTeamsFilterIDs.length - 1 }} others)
                                        </span>
                                    </template>
                                    <template v-slot:item="data">
                                        <TeamNameWithRosteredProductCategories :ref="'team'+data.item.TeamID" :teamID="data.item.TeamID" :teamName="data.item.TeamName"></TeamNameWithRosteredProductCategories>
                                    </template>
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                    </th>
                    <th v-for="(day, index) in days" 
                        :key="index"
                        colspan="2" 
                        style="width:225px;">
                        <div class="vertical-cell">
                            <span style="font-size:large">{{ moment(day.Date).format('ddd') }}</span>
                        </div>
                    </th>
                    <th style="width:100px; min-width:100px; max-width:100px; border-bottom: 1px solid rgba(0,0,0,0.12); font-size:small;" class="pa-0 font-weight-bold" rowspan="2">
                        Total Volume
                    </th>
                    <th style="width:100px; min-width:100px; max-width:100px; border-bottom: 1px solid rgba(0,0,0,0.12); font-size:small;" class="pa-0 font-weight-bold" rowspan="2">
                        Total Locations
                    </th>
                    <th style="width:100px; min-width:100px; max-width:100px; border-bottom: 1px solid rgba(0,0,0,0.12);" class="pa-0 font-weight-bold" rowspan="2">
                        RDO's
                    </th>
                </tr>
                <tr>
                    <th v-for="(i, index) in ((7 * 2) + (showPreviousSunday ? 2 : 0))"
                        :key="index">
                        <div class="vertical-cell" style="font-size:larger">
                            {{(i % 2) ? 'Volume' : '#Locations'}}
                        </div>
                    </th>
               
                </tr>
            </thead>
            <tbody v-if="filteredSelectedTeams.length == 0">
                <tr>
                    <td :colspan="18"></td>
                </tr>
            </tbody>
            <tbody v-if="filteredSelectedTeams.length > 0">
                <tr v-for="(team, i) in filteredSelectedTeams" :key="i">
                    <td class="teamColumn" style="width:15%; width:150px;">
                        <div style="width:15%; width:150px;">
                            <TeamNameWithRosteredProductCategories :teamID="team.TeamID" :teamName="team.TeamName"></TeamNameWithRosteredProductCategories>
                        </div>
                    </td>
                    <td v-for="(day, index) in duplicatedDays" :class="`${day.IsVolume ? `leftBorder` : `rightBorder`} ${isRosterDayOff(team, day) && day.IsVolume ?  'rdoCell':''}`" :key="index">
                        <div v-if="isPreviousDay($moment(day.Date)) && rosterTeamPlansByTeam[team.TeamID].NoPreviousDayData">

                        </div>
                        <div v-else-if="!isPreviousDay($moment(day.Date)) && rosterTeamPlansByTeam[team.TeamID].PreviousDayOnly">

                        </div>
                        <div v-else-if="day.IsVolume" class="vertical-cell font-weight-bold">
                            <span v-if="!isRosterDayOff(team, day)" >{{getTeamDisplayVolume(team, day) |thousandsSeparators}}{{getTeamDisplayVolume(team, day) != null ? uom:''}}</span>
                            <div v-else></div>
                        </div>
                        <div v-else class="row vertical-cell font-weight-bold" @click="updateRosterTeamPlanRosterDayOff(getRosterTeamPlan(team, day), false)">
                            <span v-if="isRosterDayOff(team, day)">
                                <v-chip color="error" text-color="white" :tabindex="-1">
                                    RDO
                                </v-chip>
                            </span>
                            <span v-else>
                                <v-tooltip bottom :disabled="getTeamRosteredLocationIDs(team, day).length <= 0">
                                    <template v-slot:activator="{ on }">
                                        <v-chip v-on="on" color="primary" text-color="white" :tabindex="-1">
                                            {{getTeamRosteredLocationIDs(team, day).length}}
                                        </v-chip>
                                    </template>
                                    <div>
                                        <ul class="no-bullets">
                                            <li v-for="(item, index) in getTeamRosteredLocationData(team, day)" :key="index">
                                                {{item.LocationName}} - {{item.VarietyName}} - {{item.RosterValue}} {{uom}}
                                            </li>
                                        </ul>
                                    </div>
                                </v-tooltip>
                            </span>
                            <v-icon v-if="day.IsPast || isPreviousDay($moment(day.Date))">lock_outline</v-icon>
                        </div>
                    </td>
                    <td class="totalVolumeRow font-weight-bold"  style="width:100px; min-width:100px; max-width:100px;">
                        <template v-if="!rosterTeamPlansByTeam[team.TeamID].PreviousDayOnly">
                            {{getTeamTotalVolume(team) |thousandsSeparators}}{{getTeamTotalVolume(team) != null ? uom: ''}}
                        </template>
                    </td>
                    <td class="totalLocationRow font-weight-bold" style="width:100px; min-width:100px; max-width:100px;">
                        <v-chip v-if="!rosterTeamPlansByTeam[team.TeamID].PreviousDayOnly" color="primary" text-color="white" :tabindex="-1">
                            {{getTeamTotalRosteredLocationIDs(team).length}}
                        </v-chip>
                    </td>
                    <td class="totalRDORow font-weight-bold" style="width:100px; min-width:100px; max-width:100px;">
                        <v-tooltip v-if="!rosterTeamPlansByTeam[team.TeamID].PreviousDayOnly" bottom :disabled="getTeamTotalRDOs(team) <= 0">
                            <template v-slot:activator="{ on }">
                                <v-chip v-on="on" color="error" text-color="white" :tabindex="-1">
                                    {{getTeamTotalRDOs(team)}}
                                </v-chip>
                            </template>
                            <div>
                                <ul class="no-bullets">
                                    <li v-for="(item, index) in getTeamRDODays(team)" :key="index">
                                        {{$moment(item).format("dddd")}}
                                    </li>
                                </ul>
                            </div>
                        </v-tooltip>
                    </td>
                </tr>
                <tr class="fillerRow">
                    <td v-for="i in 18" :key="i"></td>
                </tr>
            </tbody>
            <RosterTeamFooter v-if="expanded" :duplicatedDays="duplicatedDays" :days="days" :teams="selectedTeams" :cropLocationVarietyRosters="cropLocationVarietyRosters" />
        </table>
        <v-dialog v-if="editingRosterTeamPlan" v-model="confirmDialog"  persistent max-width="400" transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title >Confirm {{editingRosterTeamPlan.RosterDayOff == true ? 'Remove' : 'Apply'}} Roster Day Off</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    Please confirm you would like to {{editingRosterTeamPlan.RosterDayOff == true ? 'remove' : 'apply'}} this team({{filteredSelectedTeams.find(t=> t.TeamID == editingRosterTeamPlan.TeamID).TeamName}}) on {{moment(editingRosterTeamPlan.Date).format("dddd DD/MM/YYYY")}} for Roster Day Off.
                </v-card-text>
                <v-layout>
                    <v-flex xs12 class="pa-2">
                        <v-alert :value="error != null" outline type="error">
                            {{error}}
                        </v-alert>
                    </v-flex>
                   
                </v-layout>
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn block color="success" :disabled="loading" @click="updateRosterTeamPlanRosterDayOff(editingRosterTeamPlan, true)">Confirm</v-btn>
                    <v-btn block color="error" :disabled="loading" @click="confirmDialog = false">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import moment from "moment";
import RosterTeamFooter from '@/components/berriesRoster/RosterTeamFooter.vue'
import RosterUtilService from '@/services/rosterUtilService';
import TeamNameWithRosteredProductCategories from '@/components/berriesRoster/TeamNameWithRosteredProductCategories.vue'

export default {
    components: {
        RosterTeamFooter,
        TeamNameWithRosteredProductCategories
    },
    props: {
    },
    data(){
        return {
            moment,
            loading: false,
            editingRosterTeamPlan: null,
            error: null,
            confirmDialog: false,
            expanded: true,
            tempSelectedTeamsFilterIDs: this.localFilterTeamIDs
        };
    },
    computed: {
        ...mapState("RosterStore", [
            "rosterTeamPlans",
            "cropLocationVarietyRosters",
            "teamRosterResult",
            "teamRosterResultPreviousDay",
            "selectedCategoryIDs",
            "localTeamIDs",
            "localFilterTeamIDs",
            "showPreviousSunday",
            "rosterTeamPlansByTeam",
            "showActuals",
        ]),
        ...mapGetters("RosterStore", [
            "days",
            "teams",
            "selectedTeamIDs",
            "selectedTeams",
            "previousDayTeams",
            "duplicatedDays",
            "uom",
            "selectedUOMScaleFactors"
        ]),
        filteredSelectedTeams() {
            //This filter to show all the team with roster value for the selected product categories
            //Plus all the local new added team from the team management popup

            var rosteredTeams = this.selectedTeams.filter(t => {
                var result = this.teamRosterResult.find(trr => trr.TeamID == t.TeamID);

                /**
                 * This looks weird. No result or no product categories... so display the team?
                 * 
                 * I think it's because this has something to do with the teams manually selected from the Manage
                 * Team Roster functionality.
                 */

                if(result == null) {
                    return true;
                }
                else if(result.ProductCategories.length == 0) {
                    return true;
                }
                else {
                    return result.ProductCategories.find(pc=> this.selectedCategoryIDs.some(spt=> spt == pc.ProductCategoryID)) != null || this.localTeamIDs.indexOf(t.TeamID) >= 0;
                }
            });

            // this.selectedTeams has no knowledge of any of the teams from the previous Sunday
            // previous Sunday teams are in this.previousDayTeams
            // any team in here is displayed if the product categories they are rostered on for match the ones selected on the page

            var rosteredPreviousDayTeams = this.previousDayTeams.filter(t => {
                var result = this.teamRosterResultPreviousDay.find(trr => trr.TeamID == t.TeamID);

                if (result && result.ProductCategories) {
                    return result.ProductCategories.find(pc => {
                        return this.selectedCategoryIDs.some(spc => spc == pc.ProductCategoryID);
                    }) != null;
                }

                return false;
            });

            rosteredTeams = rosteredTeams.concat(rosteredPreviousDayTeams);

            // we need to eliminate any duplicate entries
            rosteredTeams = rosteredTeams.filter((team, index, self) => {
                return self.findIndex(t => t.TeamID == team.TeamID) === index;
            });

            // user is locally filtering the teams, return only the selected
            if(this.localFilterTeamIDs.length > 0){
                if(this.localFilterTeamIDs.length === 1 && this.localFilterTeamIDs[0] < 0){
                    // ONLY the spray team is selected, no need to filter rostered teams
                }
                else {
                    rosteredTeams = rosteredTeams.filter((team) => {
                        return this.localFilterTeamIDs.includes( team.TeamID )
                    })
                }
            }

            // make sure the final list is sorted
            rosteredTeams.sort(function (a, b) {
                let x = a.TeamName.toLowerCase();
                let y = b.TeamName.toLowerCase();
                if (x < y) { return -1; }
                if (x > y) { return 1; }
                return 0;
            });

            return rosteredTeams;
        },
        previousDay() {
            if (this.showPreviousSunday) {
                return moment(this.days[0].Date);
            }

            return null;
        }
    },
    methods: {
        ...mapMutations("RosterStore", [
        ]),
        ...mapActions("RosterStore", [
            "updateRosterTeamPlans",
            "updateCropLocationDaysVarietyRosters",
            "loadCropLocationVarietyRosterData",
            "localFilterTeamIDChange"
        ]),
        handleTeamFilterSelected(value){
            console.log('team filter changed', value)
            this.localFilterTeamIDChange(value)  
        },
        expand(status) {
            this.expanded = status;
            this.$emit("expand", status);
        },
        getItemIndex(index) {
            if(this.isVolmue(index)) {
                return (index+1)/2 - 1;
            } else {
                return (index-2)/2;
            }
        },
        isVolmue(index) {
            // Because the td can be either cell or team cell, only the follow index is for volume
            var i = [1, 3, 5, 7, 9, 11, 13];
            return i.indexOf(index) > -1;
        },
        isTeam(index) {
             // Because the td can be either cell or team cell, only the follow index is for team
            var i = [2, 4, 6, 8, 10, 12, 14];
            return i.indexOf(index) > -1;
        },
        isRosterDayOff(team, day) {
            var rosterTeamPlan = this.rosterTeamPlans.find(t=> t.TeamID == team.TeamID && RosterUtilService.isSameDate(t.Date, day.Date));
            if(rosterTeamPlan) {
                return rosterTeamPlan.RosterDayOff;
            } else {
                return false;
            }
        },
        getRosterTeamPlan(team, day) {
            var rosterTeamPlan = this.rosterTeamPlans.find(t=> t.TeamID == team.TeamID && RosterUtilService.isSameDate(t.Date, day.Date));
            return rosterTeamPlan;
        },
        async updateRosterTeamPlanRosterDayOff(rosterTeamPlan, confirm) {
            if(new Date().setHours(0, 0, 0, 0) > new Date(rosterTeamPlan.Date).setHours(0, 0, 0, 0)) {
                return;
            }

            if (this.isPreviousDay(moment(rosterTeamPlan.Date))) {
                return;
            }

            this.loading = false;
            this.error = null;

            if(confirm) {
                rosterTeamPlan.RosterDayOff = !rosterTeamPlan.RosterDayOff;
                try {
                    this.loading = true;
                    var promises = [];

                    // If we are marking the team to be RDO, we will go through the volume for each crop location variety and deallocate the volume to other team
                    if(rosterTeamPlan.RosterDayOff == true) {
                        var cropLocationDaysVarietyRosterList = RosterUtilService.deallocateDayVolumeForTeam(rosterTeamPlan.TeamID, rosterTeamPlan.Date, this.cropLocationVarietyRosters, this.teams);
                        if(cropLocationDaysVarietyRosterList.length > 0) {
                            await this.updateCropLocationDaysVarietyRosters(cropLocationDaysVarietyRosterList);
                            promises.push(this.loadCropLocationVarietyRosterData());
                        }
                    }
                    promises.push(this.updateRosterTeamPlans([rosterTeamPlan]));
                    await Promise.all(promises);
                    this.confirmDialog = false;
                    this.editingRosterTeamPlan = null;
                } catch(e) {
                    this.error = e.toString();
                } finally {
                    this.loading = false;
                }
            }
            else {
                this.editingRosterTeamPlan = rosterTeamPlan;
                this.confirmDialog = true;
            }
        },
        getTeamRosteredLocationData(team, day) {
            return RosterUtilService.combineTeamRosteredLocationDataIntoOneObjectPerLocation(RosterUtilService.getTeamRosteredLocationData(team, day, this.cropLocationVarietyRosters));
        },
        getTeamRosteredLocationIDs(team, day) {
            return RosterUtilService.getTeamRosteredLocationIDs(team, day, this.cropLocationVarietyRosters);
        },
        getTeamDisplayVolume(team, day) {
            if(this.showActuals && day.IsPast){
                //only show actuals for past days
                return RosterUtilService.getTeamActualVolume(team, day, this.rosterTeamPlans, this.selectedUOMScaleFactors)  
            }
            else {
                return RosterUtilService.getTeamRosteredVolume(team, day, this.cropLocationVarietyRosters);
            }
        },
        getTeamTotalVolume(team) {
            return RosterUtilService.getTeamTotalVolume(team, this.days, this.cropLocationVarietyRosters);
        },
        getTeamTotalRosteredLocationIDs(team) {
            return RosterUtilService.getTeamTotalRosteredLocationIDs(team, this.days, this.cropLocationVarietyRosters);
        },
        getTeamTotalRDOs(team) {
            return RosterUtilService.getTeamTotalRDOs(team, this.rosterTeamPlansByTeam);
        },
        getTeamRDODays(team) {
            return RosterUtilService.getTeamRDODays(team, this.rosterTeamPlansByTeam);
        },
        isPreviousDay(day) {
            return day.isSame(this.previousDay, "day");
        }
    },
    created(){
        
    }
}
</script>

<style scoped>
.vertical-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.row {
    height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.roster-team-table-scroll {
    position: absolute;
    z-index: 1;
    overflow: auto;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    min-height: 100px;
}
.roster-team-table-scroll.collapsed {
    overflow: hidden;
}
.roster-team-table-scroll table {
    width: 100%;
    height: 100%;
    margin: auto;
}

.roster-team-table-scroll table tr td, .roster-team-table-scroll table tr th {
    width: auto;
}

.roster-team-table-scroll table tbody tr td {
    width: auto;
    font-size:18px;
}

.roster-team-table-scroll thead {
    background-color: #449144 ;
}

.roster-team-table-scroll thead tr td, .roster-team-table-scroll thead tr th {
    position: -webkit-sticky;
    position: sticky;
    background-color: #449144 ;
    z-index: 5;
    color: white;

}

.roster-team-table-scroll thead tr:nth-child(1) td, .roster-team-table-scroll thead tr:nth-child(1) th {
    top: 0px;
    height: 40px!important;
    max-height: 40px;
    min-height: 40px;
}

/* .roster-team-table-scroll thead tr:nth-child(1)  {
    height: 40px!important;
    max-height: 40px;
    min-height: 40px;
} */

.roster-team-table-scroll thead tr:nth-child(2)  {
    height: 20px;
}

.roster-team-table-scroll thead tr:nth-child(2) td, .roster-team-table-scroll thead tr:nth-child(2) th {
    top: 55.56px;
    height: 20px;
}

  .roster-team-table-scroll tr:nth-child(1) th:nth-child(1) {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 25;
}

 .roster-team-table-scroll tr:nth-child(1) th:nth-last-child(1) {
    position: -webkit-sticky;
    position: sticky;
    right: 0;
    z-index: 25;
}

 .roster-team-table-scroll tr:nth-child(1) th:nth-last-child(2) {
    position: -webkit-sticky;
    position: sticky;
    right: 100px;
    z-index: 100;
}

 .roster-team-table-scroll tr:nth-child(1) th:nth-last-child(3) {
    position: -webkit-sticky;
    position: sticky;
    right: 200px;
    z-index: 100;
} 


.roster-team-table-scroll .fillerRow th, .fillerRow td {
    height: auto;
}

.roster-team-table-scroll .v-table thead tr:first-child {
    border-bottom: none;
}

.roster-team-table-scroll .v-table thead tr:nth-child(2) {
    border-bottom: 1px solid rgba(0,0,0,0.12);
}
.roster-team-table-scroll .leftBorder {
    border-left: 1px solid rgba(0,0,0,0.12);
    padding:0px;
    margin:0px;
    min-width: 120px;
    max-width: 120px;
    width: 120px;
}

.roster-team-table-scroll .rightBorder {
    border-right: 1px solid rgba(0,0,0,0.12);
    padding:0px;
    margin:0px;
    min-width: 125px;
    max-width: 125px;
    width: 125px;
}
.roster-team-table-scroll .small-cell {
        min-height: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
}

 .teamColumn {
    position: -webkit-sticky;
    position: sticky;
    left: 0px;
    z-index: 10;
    background: white;
}


 .totalVolumeRow {
    position: -webkit-sticky;
    position: sticky;
    right: 200px;
    z-index: 10;
    background: white; 
}

.totalLocationRow {
    position: -webkit-sticky;
    position: sticky;
    right: 100px;
    z-index: 10;
    background: white; 
}

.totalRDORow {
    position: -webkit-sticky;
    position: sticky;
    right: 0;
    z-index: 10;
    background: white; 
}

.rdoCell {
    background: #e0e0e0;
}

.no-bullets {
    list-style-type: none; /* Remove bullets */
    padding: 0; /* Remove padding */
    margin: 0; /* Remove margins */
}

</style>